import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'loading',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
})

/**
 * Componente para mostrar un loader
 */
export class LoadingComponent {
    @Input() public isLogo: boolean = false;

    @Input() public absolutePosition: boolean = true;

    @Input() public containerClass: string = '';
}
